// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6183 ? "e89fb3a8" : chunkId) + "." + {"2206":"5701ae35aa377eac","5078":"fb1c0353ab4a9838","6183":"a49f8b0164d790a3","6649":"72297fa4bc1df323"}[chunkId] + ".js";
};